<template>
  <modal id="invite-collaborators-modal" class="invite-modal" ref="modalWrapper" anchor="#invite" size="sx" @hidden="clearRoute" @shown="trackEventAndFocus" :hide-footer="true" :hide-header="true" :no-enforce-focus="true">
    <div id="content">
      <div>
        <div class="w-100">
          <a @click="close()" class="close-button"><img src="@img/close-icon.svg"></a>
          <div>
            <div class="side-wrapper">
              <p> Invited users will have access to shared collections and content limited to the team.</p>
              <form id="invite-form">
                <input type="text" class="email-input" placeholder="Email" id="email" ref="emailInput" v-model="inputEmail" autocomplete="off"/>
                <input type="submit" class="cloudapp-btn blue invite-button" value="Invite" @click="sendInvitation"/>
              </form>
              <p id="success-message" v-if="sentInvitation">
                Invite sent to {{sentInvitation.attributes.email}}
              </p>
              <div class="w-100 mt-3" v-if="invitationUrl">
                <p class="share-text">
                  Or share this link with your team:
                </p>
                <copy-to-clipboard :label="invitationUrl" :value="invitationUrl" :invite-template-variant="true"/>
              </div>
              <div id="errors">
                <span v-for="(error, index) in errors" :key="index" class="error">
                  {{error.detail}}
                  <a :href="`/organizations/${currentOrganization.id}`" target="_blank" v-if="/no more seats/i.test(error.detail)"> here.</a>
                </span>
              </div>
            </div>
          </div>

 
        </div>
        <div>
          <div>
            <div class="discount-container" v-if="showDiscountElement" >
            <div class="discount-badge"> 20% discount</div>
            <div class="discount-text">Invite {{membersUntillDiscount}} more member{{membersUntillDiscount == 2 ? 's': ''}} and reduce your price to <span class="strikethrough">$9.95</span> $8/member.</div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import track from '@/src/tracking';
import { mapState } from 'vuex';
import featureKey from "../feature_key.macro";
import Modal from '@/src/components/modal.vue';

TimeAgo.addDefaultLocale(en);

export default {
  components: { Modal, CopyToClipboard: () => import("@cmp/copy_to_clipboard.vue") },
  data: function(){
    return {
      loading: true,
      inputEmail: "",
      sentInvitation: null,
      errors: [],
      inviteSource: "",
      membersCountThreshold: 3
    }
  },
  computed: {
    ...mapState({
      showMemberDiscountFlag: (state) => state.features?.[featureKey("web-show-pro-member-discount")],
      currentOrganization: (state) => state.currentOrganization,
      membersCount: (state)=> state.currentOrganization.relationships.members.data.length
    }),

    
    invitationUrl: function() {
      return this.currentOrganization?.links?.invitation_url;
    },
    
    membersUntillDiscount: function(){
     return this.membersCountThreshold - this.membersCount
    },
    isProOrganization:function(){
      return this.currentOrganization?.attributes.plan_code.includes('pro')
    },
    showDiscountElement: function(){
      return this.isProOrganization && this.membersCount < 3 && this.showMemberDiscountFlag
    }

  },
  methods: {
    trackEventAndFocus: function(){
      track("viewed_invite_modal", { url: this.$route.fullPath })
      this.$refs.emailInput.focus();
    },
    
    clearRoute: function(){
      this.$router.push({ path: this.$route.path, hash: null });
    },
    close: function(){
      this.$refs.modalWrapper.$refs.modal.hide();
    },
    timeAgoInWords: function(date){
      const timeAgo = new TimeAgo('en-US');
      return timeAgo.format(new Date(date));
    },
    sendInvitation: function(e){
      e.preventDefault();
      const vm = this;
      const params = {
        organizationId: this.currentOrganization.id,
        params: {
          emails: [this.inputEmail],
          source: this.inviteSource,
        },
      };
      this.$store.dispatch('createInvitation', params)
        .then(function(response) {
          vm.inputEmail = "";
          vm.sentInvitation = response.data.data.invitations[0];
        }).catch(function(err){
          vm.errors = err.response.data.errors;
      })
    },
    setInviteSource: function (e) {
      if (e.target.hash === "#invite") {
        this.inviteSource = e.target.dataset.testid;
      }
    }
  },
  mounted: function () {
    document.addEventListener("click", this.setInviteSource);
  },
}
</script>
<style lang="scss">
  #invite-collaborators-modal___BV_modal_outer_ {
    z-index: 1042 !important;
  }
</style>
<style lang="scss" scoped>
  @import "application.scss";

  .side-wrapper {
    display: flex;
    flex-direction: column;
  }
  .invite-modal{
    max-width:480px;
    width:100%;
  }
  .invite-button{
    width: 90px;
  }
  .close-button{
    position: absolute;
    right: 21px;
    top: 21px;
    cursor: pointer;
  }
  #content{
    padding: 50px;
  }
  #overview {
    background: $dark-blue;
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
    width: 100%;
    color: white;

    #overview-copy {
      margin-top: 30px;
    }
  }

  #close {
    color: white;
    text-align: right;

    a {
      cursor: pointer;
    }
  }

  #invite-form {
    display: flex;
    margin-top: 20px;
  }

  #success-message {
    margin-top: 10px;
  }

  #errors {
    margin-bottom: 20px;

    .error {
      color: $radical-red;
      font-size: 11px;
      display: block;
    }
  }

  .cloudapp-btn {
    border-radius: 5px;
    height: 2rem;
    padding: 0 1rem;
    outline: none;
    font-size:0.8rem;
  }

  .email-input {
    height: 2rem;
    padding: 0.5rem 2.188rem 0.5rem 0.5rem;
    font-size: 0.75rem;
    width: 100%;
    background: $pale-gray;
    border: none;
    border-bottom: 1px $almost-black solid;
    border-radius: 0;
    outline: 0;
    margin-right: 22px;

    &:focus {
      border-bottom: 2px $bright-blue solid;
    }
  }
  .share-text{
    margin:0;
  }
  .discount-container{
    border: 1px solid #E1E8F0;
    border-radius:8px;
    padding:10px;
    .discount-badge{
      background: linear-gradient(89.93deg, #E39C3C 3.67%, #EA6A5B 92.9%);
      border-radius: 4px;
      padding: 2px 4px;
      color:$white;
      width:auto;
      display:inline-flex;
      margin: 0 0 8px 0;
      font-size:12px;
    }
    .discount-text{
      font-size:14px;
    }
    .strikethrough{
      text-decoration: line-through;
    }
  }
</style>


<style>
 /* bootstrap-vue parent elements are not really scoped, need to overwrite here */
 #invite-collaborators-modal .modal-body {
   padding: 0;
 }

 #invite-collaborators-modal .modal-content {
   border: none;
  }
</style>
